import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetUserRoles = (organisationType) =>
  axios.get(`${apiPaths.userRolesBase}?organization_type=${organisationType}`);

const onGetUsers = (params) => axios.get(apiPaths.usersBase, { params });
const onCreateUser = (user) => axios.post(apiPaths.usersBase, user);
const onUpdateUser = (userId, user) => axios.put(`${apiPaths.usersBase}/${userId}`, user);
const onDeleteUser = (userId) => axios.delete(`${apiPaths.usersBase}/${userId}`);

export { onGetUserRoles, onGetUsers, onCreateUser, onUpdateUser, onDeleteUser };
